import React from "react";
import { Link } from "react-router-dom";
import { empty } from "../../../utils";

const Templates = (props) => {
    const renderStaticTemplates = () => {
        if (props.fetching || props.department == null) {
            return (
                <div>
                    <i className="fas fa-circle-notch fa-spin" /> Loading
                    data...
                </div>
            );
        }

        if (props.products.length === 0) {
            return <div>No items available.</div>;
        }

        const products = [...props.products];

        if (
            parseInt(props.productType) === 4 &&
            parseInt(props.department.id) === 419
        ) {
            products.push({
                id: 640,
                front_image_url:
                    "https://ac-ut-health.s3.amazonaws.com/static-preview-images/ut-disclosure-notice-regarding-patient-protections-against-surprise-billing-tx.png",
                name: "Your Rights and Protections Against Surprise Medical Bills Disclosure Notice (English)",
            });

            products.push({
                id: 647,
                front_image_url:
                    "https://ac-ut-health.s3.amazonaws.com/static-preview-images/patient-code-of-conduct.png",
                name: <div>Patient Code of Conduct</div>,
            });
        }

        return products.map((product) => {
            let url =
                "/static-template/" +
                props.productId +
                "/" +
                props.department.id +
                "/" +
                product.id;
            let imageStyle = {
                backgroundImage: 'url("' + product.image_url + '")',
                backgroundSize: "75%",
            };

            if (parseInt(product.id) === 649) {
                imageStyle = {
                    backgroundImage: 'url("' + product.image_url + '")',
                    backgroundSize: "contain",
                };
            }

            let color = "";
            if (parseInt(props.productType) === 2) {
                let imageUrl = require("./../images/no-image.jpg");
                if (
                    product.preview_image_url &&
                    product.preview_image_url != null &&
                    product.preview_image_url !== "" &&
                    product.preview_image_url !== "-"
                ) {
                    imageUrl = product.preview_image_url;
                }

                url =
                    "/apparel-item/" +
                    props.productId +
                    "/" +
                    props.department.id +
                    "/" +
                    product.id;
                imageStyle = {
                    backgroundImage: 'url("' + imageUrl + '")',
                    backgroundSize: "cover",
                };

                if (parseInt(product.logic_version) === 2) {
                    color = " (" + product.color + ")";
                }
            } else if (parseInt(props.productType) === 3) {
                url =
                    "/promotional-item/" +
                    props.productId +
                    "/" +
                    props.department.id +
                    "/" +
                    product.id;

                if (
                    props.user.username === "utdemo" &&
                    !empty(product.preview_image_url_demo)
                ) {
                    imageStyle = {
                        backgroundImage:
                            'url("' + product.preview_image_url_demo + '")',
                        backgroundSize: "contain",
                    };
                } else {
                    imageStyle = {
                        backgroundImage:
                            'url("' + product.preview_image_url + '")',
                        backgroundSize: "contain",
                    };
                }

                if (
                    parseInt(props.department.id) === 377 &&
                    parseInt(product.id) === 22
                ) {
                    url = "/myuthealth/3/9";
                }
            } else if (parseInt(props.productType) === 4) {
                let backgroundUrl = product.front_image_url;

                url =
                    "/brochure/" +
                    props.productId +
                    "/" +
                    props.department.id +
                    "/" +
                    product.id;

                let percentage = "90%";
                if (parseInt(product.id) === 2) {
                    percentage = "70%";
                } else if ([3, 4, 5, 6, 7, 13].includes(parseInt(product.id))) {
                    percentage = "72%";
                    color = (
                        <div className="mt-1">
                            <b>Framed Poster</b>
                        </div>
                    );
                } else if ([9, 14].includes(parseInt(product.id))) {
                    percentage = "62%";
                    color = (
                        <div className="mt-1">
                            <b>Framed Poster</b>
                        </div>
                    );
                } else if (parseInt(product.id) === 10) {
                    percentage = "68%";
                    color = (
                        <div className="mt-1">
                            <b>Framed Poster</b>
                        </div>
                    );
                } else if (parseInt(product.id) === 11) {
                    percentage = "68%";
                }

                if (parseInt(product.id) === 640) {
                    percentage = "71%";
                    url = "/static-template/5/338/" + product.id;
                    color = (
                        <div className="mt-1">
                            <b>Handout</b>
                        </div>
                    );
                } else if ([468, 511].includes(parseInt(product.id))) {
                    percentage = "75%";
                    url = "/static-template/5/330/" + product.id;
                    backgroundUrl = product.image_url;
                } else if (parseInt(product.id) === 647) {
                    percentage = "71%";
                    url = "/static-template/5/338/" + product.id;
                    color = (
                        <div className="mt-1">
                            <b>Framed Poster</b>
                            <br />
                            or
                            <br />
                            <b>Static Cling Poster</b>
                        </div>
                    );
                }

                imageStyle = {
                    backgroundImage: 'url("' + backgroundUrl + '")',
                    backgroundSize: percentage,
                    backgroundColor: "#dadce0",
                };
            }

            let limitMessage = null;
            if (props.department.is_for_manager) {
                limitMessage = " - Limit 5 per Employee per Year";
            }

            let banner = null;
            if (product.is_maternity) {
                banner = <div className="maternity-banner">Maternity</div>;
            }
            if (product.is_for_international) {
                banner = (
                    <div className="international-banner">
                        International District Only
                    </div>
                );
            }
            if (product.is_for_international && product.is_maternity) {
                banner = (
                    <div className="maternity-banner">
                        International/Maternity
                    </div>
                );
            }
            if (product.is_clearance) {
                banner = <div className="clearance-banner">Clearance</div>;
            }
            if (product.is_petite) {
                banner = <div className="petite-banner">Petite</div>;
            }
            if (product.is_tall) {
                banner = <div className="tall-banner">Tall</div>;
            }
            if (product.is_short) {
                banner = <div className="short-banner">Short</div>;
            }
            if (product.is_special_events) {
                banner = (
                    <div className="special-events-banner">
                        Special Events Options
                    </div>
                );
            }
            if (product.is_obgyn) {
                banner = <div className="obgyn-banner">OB-GYN</div>;
            }

            return (
                <div className="category" key={product.id}>
                    <Link to={url} style={{ textDecoration: "none" }}>
                        <div className="image" style={imageStyle}>
                            {banner}
                        </div>
                    </Link>
                    <div className="title">
                        <div className="name">
                            {product.name}
                            {color}
                            {limitMessage}
                        </div>
                        <div className="button-container">
                            <Link to={url}>
                                <button>Select</button>
                            </Link>
                        </div>
                    </div>
                </div>
            );
        });
    };

    let breadcrumbsContainer = null;
    if (parseInt(props.productId) === 5 && props.department != null) {
        breadcrumbsContainer = (
            <div className="breadcrumbs">
                / <Link to="/utp">Main Categories</Link> /{" "}
                <Link to="/product/5">Forms Categories</Link> /{" "}
                {props.department.name}
            </div>
        );
    } else if (parseInt(props.productId) === 6 && props.department != null) {
        breadcrumbsContainer = (
            <div className="breadcrumbs">
                / <Link to="/utp">Main Categories</Link> /{" "}
                <Link to="/product/6">COVID-19 Categories</Link> /{" "}
                {props.department.name}
            </div>
        );
    } else if (parseInt(props.productId) === 7 && props.department != null) {
        const breadcrumbs = [
            <Link to="/utp">Main Categories</Link>,
            " / ",
            <Link to="/product/7">Apparel Categories</Link>,
        ];

        for (let i = 0; i < props.department.breadcrumbs.length; i++) {
            breadcrumbs.push(
                " / ",
                <Link to={"/product/7/" + props.department.breadcrumbs[i].id}>
                    {props.department.breadcrumbs[i].label}
                </Link>
            );
        }

        breadcrumbs.push(" / ", props.department.name);
        breadcrumbsContainer = (
            <div className="breadcrumbs">/ {breadcrumbs}</div>
        );
    } else if (parseInt(props.productId) === 8 && props.department != null) {
        breadcrumbsContainer = (
            <div className="breadcrumbs">
                / <Link to="/utp">Main Categories</Link> / Promotional
            </div>
        );
    } else if (parseInt(props.productId) === 16 && props.department != null) {
        let categoryName = "Marketing Collateral";
        if (parseInt(props.department.id) === 419) {
            categoryName = "Legal Notices";
        }

        breadcrumbsContainer = (
            <div className="breadcrumbs">
                / <Link to="/utp">Main Categories</Link> / {categoryName}
            </div>
        );
    }

    let holdersItem = null;
    let promoCardItem = null;
    if (
        !props.fetching &&
        props.department != null &&
        parseInt(props.department.id) === 412
    ) {
        holdersItem = (
            <div className="category">
                <Link to="/promotional-item/8/377/14">
                    <div className="image p14-t4"></div>
                </Link>
                <div className="title">
                    <div className="name">Tri-Fold Holders</div>
                    <div className="button-container">
                        <Link to="/promotional-item/8/377/14">
                            <button>Select</button>
                        </Link>
                    </div>
                </div>
            </div>
        );
        promoCardItem = (
            <div className="category">
                <Link to="/myuthealth/6/13">
                    <div className="image p14-t13"></div>
                </Link>
                <div className="title">
                    <div className="name">
                        UTHealth Houston Text Messaging Promo Card (Epic Hello
                        World)
                    </div>
                    <div className="button-container">
                        <Link to="/myuthealth/6/13">
                            <button>Select</button>
                        </Link>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="templates-container">
            {breadcrumbsContainer}
            <div className="templates-row">
                {renderStaticTemplates()}
                {holdersItem}
                {promoCardItem}
            </div>
        </div>
    );
};

export default Templates;
